import { FC } from 'react';
import { useTypedDispatch } from '../../hooks/useTypedDispatch';
import { useTypedSelector } from '../../hooks/useTypedSelector';
import QuickFilterGroups from '../common/filter/QuickFilterGroups';
import { geTImportsFilterParams, setImportsFilterParams, TImportsFilterFields } from '../../store/importsSlice';

const ImportFiltersQuick: FC = () => {
  const dispatch = useTypedDispatch();
  const filterParams = useTypedSelector(geTImportsFilterParams()); 
  
  const handleToggleFilter = (filterKey: TImportsFilterFields, filterValue: string) =>
    () => dispatch(setImportsFilterParams({
      ...filterParams,
      [filterKey]: filterParams?.[filterKey] === filterValue
        ? ''
        : filterValue,
    }));

  const isInStrArr = (value: string, strArr: string): boolean => !!strArr.split(',').find((val) => val === value);
  const setValueFromStrArr = (value: string, strArr: string): string => [value, ...strArr.split(',')].join(',');
  const unsetValueFromStrArr = (value: string, strArr: string): string => strArr.split(',').filter((val) => val !== value).join(',');

  const handleToggleStrArr = (filterKey: TImportsFilterFields, value: string,) => 
    () => dispatch(setImportsFilterParams({
      ...filterParams,
      [filterKey]: isInStrArr(value, filterParams?.[filterKey])
        ? unsetValueFromStrArr(value, filterParams?.[filterKey])
        : setValueFromStrArr(value, filterParams?.[filterKey]),
    }));

  return (
    <div className="flex gap-4 pl-4">
      <QuickFilterGroups
        preDivider
        groups={[
          {
            title: 'Platform',
            filters: {
              options: [
                { 
                  label: 'PCNA', 
                  onClick: handleToggleFilter('company', 'pcna'),
                  active: filterParams.company === 'pcna',
                },
                { 
                  label: 'HIT',
                  onClick: handleToggleFilter('company', 'hit'),
                  active: filterParams.company === 'hit',
                },
              ]
            }
          },
          {
            title: 'Status',
            filters: {
              options: [
                { 
                  label: 'All', 
                  onClick: handleToggleFilter('status', ''),
                  active: filterParams.status === '',
                },
                { 
                  label: 'Fullfild', 
                  onClick: handleToggleStrArr('status', '2'),
                  active: isInStrArr('2', filterParams.status),
                },
                { 
                  label: 'Error',
                  onClick: handleToggleStrArr('status', '3'),
                  active: isInStrArr('3', filterParams.status),
                },
                { 
                  label: 'Warning',
                  onClick: handleToggleStrArr('status', '4'),
                  active: isInStrArr('4', filterParams.status),
                },
              ]
            }
          },
        ]}
      />
    </div>    
  );
}

export default ImportFiltersQuick;
